import React, { createContext, useContext, useEffect, useState } from "react";

export type Language = "th" | "my";

export interface TranslationDict {
  // Brand & Header
  appTitle: string;
  appBadge: string;
  appSubtitle: string;
  userRoleExecutive: string;
  userLoggedAs: string;
  changeUserTooltip: string;
  
  // Language switcher
  langThai: string;
  langBurmese: string;

  // Onboarding
  welcomeBadge: string;
  onboardingTitle: string;
  onboardingSub: string;
  selectFromRoster: string;
  selectNamePlaceholder: string;
  orTypeOwnName: string;
  typeOwnPlaceholder: string;
  loginAndStartBtn: string;
  confirmThisName: string;

  // Tabs
  tabAttendance: string;
  tabAdvance: string;
  tabLeave: string;
  tabStats: string;
  tabTasks: string;
  tabWelfare: string;
  tabLiveBoard: string;
  tabPayroll: string;
  tabAdvanceApprovals: string;
  tabLeaveApprovals: string;
  tabTeam: string;
  tabSettings: string;
  selectLanguageTitle: string;

  // Attendance Hero & Clock
  activeEmployeeTitle: string;
  workDateLabel: string;
  unassignedEmployee: string;
  statusDone: string;
  statusWorking: string;
  statusNotStarted: string;
  syncReady: string;
  syncSuccess: string;
  thailandStandardTime: string;

  // Location
  autoLocationLabel: string;
  locationDetecting: string;
  locationReady: string;
  locationRefreshTooltip: string;

  // Check In & Check Out
  btnCheckIn: string;
  btnCheckInDone: string;
  btnCheckOut: string;
  btnCheckOutDone: string;
  checkInAtTime: string;
  checkOutAtTime: string;
  workedDuration: string;
  autoLocationNotice: string;
  checkInCoordLabel: string;
  checkOutCoordLabel: string;
  openMapLink: string;
  waitingCheckOut: string;

  // Shortcuts
  quickAdvanceTitle: string;
  quickAdvanceSub: string;
  quickLeaveTitle: string;
  quickLeaveSub: string;

  // Work Rules
  workRulesTitle: string;
  workRulesDesc: string;

  // History
  recentHistoryTitle: string;
  viewAllStats: string;
  noRecentHistory: string;

  // Modals & Confirmation
  confirmCheckInTitle: string;
  confirmCheckInBody: string;
  confirmCheckOutTitle: string;
  confirmCheckOutBody: string;
  modalCancel: string;
  modalConfirm: string;
  successCheckInTitle: string;
  successCheckInSub: string;

  // Salary Advance Tab
  advanceHeading: string;
  advanceSubheading: string;
  advanceWorkedDays: string;
  advanceMaxLimit: string;
  advanceAmountLabel: string;
  advanceAmountPlaceholder: string;
  advanceReasonLabel: string;
  advanceReasonPlaceholder: string;
  advanceSubmitBtn: string;
  advanceCutoffNotice: string;
  advancePendingNote: string;
  advanceHistoryTitle: string;

  // Leave Tab
  leaveHeading: string;
  leaveSubheading: string;
  leaveTypeLabel: string;
  leaveTypeVacation: string;
  leaveTypeSick: string;
  leaveTypeBusiness: string;
  leaveStartDate: string;
  leaveEndDate: string;
  leaveReason: string;
  leaveSubmitBtn: string;
}

export const translations: Record<Language, TranslationDict> = {
  th: {
    appTitle: "ศิรารันดร์",
    appBadge: "Check-In",
    appSubtitle: "ระบบลงเวลา บริษัท ศิรารันดร์ คอนสตรัคชั่น จำกัด",
    userRoleExecutive: "EXECUTIVE & HR",
    userLoggedAs: "ผู้ใช้งาน:",
    changeUserTooltip: "เปลี่ยนผู้ใช้งาน / ลบชื่อที่จำไว้",

    langThai: "ไทย",
    langBurmese: "မြန်မာ",

    welcomeBadge: "ยินดีต้อนรับสู่ระบบ ศิรารันดร์ Check-In",
    onboardingTitle: "ระบุชื่อ-นามสกุลของคุณเพื่อเริ่มใช้งาน",
    onboardingSub: "เลือกชื่อจากรายชื่อพนักงาน หรือพิมพ์ชื่อ-นามสกุลของคุณ ระบบจะจดจำไว้ใช้งานครั้งถัดไปโดยอัตโนมัติ",
    selectFromRoster: "เลือกจากรายชื่อพนักงานในระบบ",
    selectNamePlaceholder: "-- กรุณาแตะเลือกชื่อของคุณ --",
    orTypeOwnName: "หรือพิมพ์ระบุชื่อเอง",
    typeOwnPlaceholder: "พิมพ์ชื่อ-นามสกุล (เช่น นายสมชาย ใจดี)",
    loginAndStartBtn: "เข้าสู่ระบบและเริ่มลงเวลา",
    confirmThisName: "ยืนยันชื่อนี้",

    tabAttendance: "ลงเวลาเข้า-ออก",
    tabAdvance: "ขอเบิกเงินล่วงหน้า",
    tabLeave: "วันลาของฉัน",
    tabStats: "สถิติของฉัน",
    tabTasks: "งานของฉัน / OT",
    tabWelfare: "สวัสดิการ",
    tabLiveBoard: "ภาพรวมวันนี้",
    tabPayroll: "เงินเดือน & OT",
    tabAdvanceApprovals: "อนุมัติเบิกเงิน",
    tabLeaveApprovals: "อนุมัติวันลา",
    tabTeam: "จัดการทีม",
    tabSettings: "ตั้งค่า HR",
    selectLanguageTitle: "เลือกภาษาที่ต้องการใช้งาน:",

    activeEmployeeTitle: "พนักงานที่เข้าใช้งาน",
    workDateLabel: "วันที่ทำงานไทย:",
    unassignedEmployee: "ยังไม่ระบุชื่อพนักงาน",
    statusDone: "บันทึกเวลาครบแล้ว",
    statusWorking: "กำลังปฏิบัติงาน",
    statusNotStarted: "ยังไม่ลงเวลาเข้างาน",
    syncReady: "พร้อมสำหรับการบันทึก",
    syncSuccess: "ซิงก์ฐานข้อมูลเรียบร้อย",
    thailandStandardTime: "เวลามาตรฐานประเทศไทย (ICT)",

    autoLocationLabel: "ตำแหน่งอัตโนมัติ:",
    locationDetecting: "กำลังตรวจจับพิกัด GPS...",
    locationReady: "พร้อมระบุพิกัดอัตโนมัติขณะกดบันทึก",
    locationRefreshTooltip: "รีเฟรชพิกัด GPS",

    btnCheckIn: "เช็คอิน",
    btnCheckInDone: "เช็คอินแล้ว",
    btnCheckOut: "เช็คเอาท์",
    btnCheckOutDone: "เช็คเอาท์แล้ว",
    checkInAtTime: "เข้างานเมื่อ",
    checkOutAtTime: "ออกงานเมื่อ",
    workedDuration: "ปฏิบัติงานแล้ว",
    autoLocationNotice: "ขึ้นพิกัด Location อัตโนมัติ",
    checkInCoordLabel: "พิกัดเช็คอิน:",
    checkOutCoordLabel: "พิกัดเช็คเอาท์:",
    openMapLink: "ดูตำแหน่งบนแผนที่",
    waitingCheckOut: "รอเช็คเอาท์",

    quickAdvanceTitle: "ขอเบิกเงินล่วงหน้า",
    quickAdvanceSub: "เบิกได้ตามวันที่ทำงานจริง (ตัดรอบ 10, 25)",
    quickLeaveTitle: "ขอลางานออนไลน์",
    quickLeaveSub: "ยื่นคำขอลา พร้อมสถานะอนุมัติ/ไม่อนุมัติ",

    workRulesTitle: "เกณฑ์เวลางานและ OT:",
    workRulesDesc: "เวลางานมาตรฐาน 8 ชม. (หักพัก 1 ชม.) · ทำงานเกิน 8 ชม. 30 นาทีขึ้นไป เริ่มคิด OT ปัดเศษขึ้นเป็นชั่วโมงเต็ม (สูตร: ค่าแรงรายวัน ÷ 8 × 1.5)",

    recentHistoryTitle: "ประวัติลงเวลาล่าสุด",
    viewAllStats: "ดูสถิติทั้งหมด",
    noRecentHistory: "ยังไม่มีประวัติการลงเวลาล่าสุด",

    confirmCheckInTitle: "ยืนยันการลงชื่อเข้างาน?",
    confirmCheckInBody: "ระบบจะบันทึกเวลาเข้างานพร้อมพิกัด GPS อัตโนมัติ",
    confirmCheckOutTitle: "ยืนยันการลงชื่อออกงาน?",
    confirmCheckOutBody: "ระบบจะบันทึกเวลาออกงานและคำนวณชั่วโมงทำงานพร้อม OT อัตโนมัติ",
    modalCancel: "ยกเลิก",
    modalConfirm: "ยืนยัน",
    successCheckInTitle: "เช็คอินสำเร็จ!",
    successCheckInSub: "บันทึกเวลาเข้างานเรียบร้อยแล้ว",

    advanceHeading: "ขอเบิกเงินล่วงหน้า",
    advanceSubheading: "คำนวณสิทธิ์ตามวันที่ทำงานจริงในรอบปัจจุบัน (ตัดรอบทุกวันที่ 10 และ 25)",
    advanceWorkedDays: "วันที่ทำงานจริงในรอบนี้:",
    advanceMaxLimit: "ยอดเงินที่สามารถเบิกได้สูงสุด:",
    advanceAmountLabel: "จำนวนเงินที่ต้องการเบิก (บาท):",
    advanceAmountPlaceholder: "ระบุจำนวนเงิน เช่น 500",
    advanceReasonLabel: "เหตุผลความจำเป็น:",
    advanceReasonPlaceholder: "ระบุเหตุผลความจำเป็น เช่น ค่าใช้จ่ายฉุกเฉิน",
    advanceSubmitBtn: "ส่งคำขอเบิกเงินล่วงหน้า",
    advanceCutoffNotice: "ระยะเวลาตัดรอบเงินเดือน: ทุกวันที่ 10 และ 25 ของเดือน",
    advancePendingNote: "คำขอของคุณจะถูกส่งให้ผู้บริหารพิจารณาอนุมัติ",
    advanceHistoryTitle: "ประวัติการขอเบิกเงินล่วงหน้า",

    leaveHeading: "ยื่นใบลาออนไลน์",
    leaveSubheading: "กรอกข้อมูลและส่งคำขอลางานเพื่อรอการพิจารณาอนุมัติ",
    leaveTypeLabel: "ประเภทการลา:",
    leaveTypeVacation: "ลาพักร้อน (Vacation)",
    leaveTypeSick: "ลาป่วย (Sick Leave)",
    leaveTypeBusiness: "ลากิจ (Business Leave)",
    leaveStartDate: "ตั้งแต่วันที่:",
    leaveEndDate: "ถึงวันที่:",
    leaveReason: "เหตุผลการลา:",
    leaveSubmitBtn: "ส่งคำขอลางาน",
  },

  my: {
    appTitle: "Sirarund",
    appBadge: "Check-In",
    appSubtitle: "ဆောက်လုပ်ရေးဝန်ထမ်းများအတွက် အလုပ်ချိန်မှတ်တမ်းစနစ်",
    userRoleExecutive: "စီမံခန့်ခွဲသူနှင့် HR",
    userLoggedAs: "အသုံးပြုသူ:",
    changeUserTooltip: "အသုံးပြုသူ ပြောင်းရန် / အမည်ဖျက်ရန်",

    langThai: "ไทย",
    langBurmese: "မြန်မာ",

    welcomeBadge: "Sirarund Check-In စနစ်မှ ကြိုဆိုပါသည်",
    onboardingTitle: "စတင်အသုံးပြုရန် သင်၏အမည်ကို ရွေးချယ်ပါ",
    onboardingSub: "စနစ်ထဲရှိ ဝန်ထမ်းစာရင်းမှ အမည်ရွေးပါ သို့မဟုတ် ကိုယ်တိုင်ရိုက်ထည့်ပါ စနစ်မှ အလိုအလျောက် မှတ်သားထားမည်ဖြစ်သည်",
    selectFromRoster: "စနစ်ထဲရှိ ဝန်ထမ်းစာရင်းမှ ရွေးချယ်ပါ",
    selectNamePlaceholder: "-- ကျေးဇူးပြု၍ သင်၏အမည်ကို ရွေးပါ --",
    orTypeOwnName: "သို့မဟုတ် အမည်ကိုယ်တိုင် ရိုက်ထည့်ပါ",
    typeOwnPlaceholder: "အမည်ရိုက်ထည့်ပါ (ဥပမာ- ကိုအောင်)",
    loginAndStartBtn: "အတည်ပြုပြီး အလုပ်စတင်မှတ်တမ်းတင်မည်",
    confirmThisName: "ဤအမည်ကို အတည်ပြုမည်",

    tabAttendance: "အလုပ်တက်/ဆင်း",
    tabAdvance: "လစာကြိုထုတ်",
    tabLeave: "ခွင့်ရက်များ",
    tabStats: "မိမိမှတ်တမ်း",
    tabTasks: "မိမိတာဝန်များ / OT",
    tabWelfare: "သက်သာချောင်ချိရေး",
    tabLiveBoard: "ယနေ့ အကျဉ်းချုပ်",
    tabPayroll: "လစာနှင့် အချိန်ပို OT",
    tabAdvanceApprovals: "ကြိုထုတ်ခွင့်ပြုရန်",
    tabLeaveApprovals: "ခွင့်ခွင့်ပြုရန်",
    tabTeam: "ဝန်ထမ်းစာရင်း",
    tabSettings: "HR ဆက်တင်များ",
    selectLanguageTitle: "အသုံးပြုလိုသည့် ဘာသာစကား ရွေးချယ်ပါ:",

    activeEmployeeTitle: "လက်ရှိအသုံးပြုနေသော ဝန်ထမ်း",
    workDateLabel: "အလုပ်လုပ်သည့်ရက်စွဲ:",
    unassignedEmployee: "ဝန်ထမ်းအမည် မသတ်မှတ်ရသေးပါ",
    statusDone: "အချိန်မှတ်တမ်းတင်ပြီးပါပြီ",
    statusWorking: "အလုပ်လုပ်နေဆဲဖြစ်သည်",
    statusNotStarted: "အလုပ်မဝင်ရသေးပါ",
    syncReady: "မှတ်တမ်းတင်ရန် အဆင်သင့်ရှိသည်",
    syncSuccess: "အချက်အလက် သိမ်းဆည်းပြီးပါပြီ",
    thailandStandardTime: "ထိုင်းစံတော်ချိန် (ICT)",

    autoLocationLabel: "အလိုအလျောက် တည်နေရာ:",
    locationDetecting: "GPS တည်နေရာ ရှာဖွေနေပါသည်...",
    locationReady: "မှတ်တမ်းတင်ရန် တည်နေရာ အဆင်သင့်ရှိပါသည်",
    locationRefreshTooltip: "GPS ပြန်လည်ရှာဖွေရန်",

    btnCheckIn: "အလုပ်ဝင် (Check-in)",
    btnCheckInDone: "အလုပ်ဝင်ပြီးပါပြီ",
    btnCheckOut: "အလုပ်ဆင်း (Check-out)",
    btnCheckOutDone: "အလုပ်ဆင်းပြီးပါပြီ",
    checkInAtTime: "အလုပ်ဝင်ချိန်",
    checkOutAtTime: "အလုပ်ဆင်းချိန်",
    workedDuration: "အလုပ်ချိန်ကြာမြင့်ချိန်",
    autoLocationNotice: "GPS တည်နေရာ အလိုအလျောက်ပါဝင်မည်",
    checkInCoordLabel: "အလုပ်ဝင် တည်နေရာ:",
    checkOutCoordLabel: "အလုပ်ဆင်း တည်နေရာ:",
    openMapLink: "မြေပုံတွင် ကြည့်ရှုရန်",
    waitingCheckOut: "အလုပ်ဆင်းရန် စောင့်ဆိုင်းဆဲ",

    quickAdvanceTitle: "လစာကြိုထုတ် လျှောက်ထားခြင်း",
    quickAdvanceSub: "အမှန်တကယ်ဆင်းထားသော ရက်အတိုင်းထုတ်ယူနိုင်သည် (၁၀၊ ၂၅ ရက်)",
    quickLeaveTitle: "ခွင့်ရက် လျှောက်ထားခြင်း",
    quickLeaveSub: "ခွင့်တောင်းရန်နှင့် ခွင့်ပြုချက် ကြည့်ရှုရန်",

    workRulesTitle: "အလုပ်ချိန်နှင့် အချိန်ပို OT စည်းမျဉ်းများ:",
    workRulesDesc: "ပုံမှန်အလုပ်ချိန် ၈ နာရီ (နားချိန် ၁ နာရီနုတ်ပြီး) · အလုပ်ဆင်းချိန်ထက် မိနစ် ၃၀ ကျော်ပါက OT စတင်တွက်ချက်သည်၊ နာရီဝက်ကျော်ပါက ၁ နာရီအပြည့်သတ်မှတ်သည် (တွက်ချက်ပုံ: နေ့စားခ ÷ ၈ × ၁.၅)",

    recentHistoryTitle: "လတ်တလော အလုပ်ဆင်းချိန် မှတ်တမ်း",
    viewAllStats: "မှတ်တမ်းအားလုံး ကြည့်ရန်",
    noRecentHistory: "လတ်တလော မှတ်တမ်းမရှိသေးပါ",

    confirmCheckInTitle: "အလုပ်စတင်ဝင်ရောက်မှုကို အတည်ပြုပါသလား?",
    confirmCheckInBody: "စနစ်သည် လက်ရှိအချိန်နှင့် GPS တည်နေရာကို အလိုအလျောက် မှတ်တမ်းတင်ပါမည်",
    confirmCheckOutTitle: "အလုပ်ဆင်းမှုကို အတည်ပြုပါသလား?",
    confirmCheckOutBody: "စနစ်သည် အလုပ်ဆင်းချိန်နှင့် အချိန်ပို OT ကို အလိုအလျောက် တွက်ချက်မှတ်တမ်းတင်ပါမည်",
    modalCancel: "မလုပ်တော့ပါ",
    modalConfirm: "အတည်ပြုသည်",
    successCheckInTitle: "အလုပ်ဝင် မှတ်တမ်းတင်ပြီးပါပြီ!",
    successCheckInSub: "အလုပ်ဝင်ချိန် အောင်မြင်စွာ မှတ်တမ်းတင်ပြီးပါပြီ",

    advanceHeading: "လစာကြိုထုတ် လျှောက်ထားခြင်း",
    advanceSubheading: "လက်ရှိလ အလုပ်ဆင်းရက်ပေါ် မူတည်၍ တွက်ချက်သည် (လစဉ် ၁၀ နှင့် ၂၅ ရက် ဖြတ်သည်)",
    advanceWorkedDays: "လက်ရှိအလုပ်ဆင်းရက် စုစုပေါင်း:",
    advanceMaxLimit: "အများဆုံး ထုတ်ယူနိုင်သည့်ငွေ:",
    advanceAmountLabel: "ထုတ်ယူလိုသောငွေပမာဏ (ဘတ်):",
    advanceAmountPlaceholder: "ငွေပမာဏ ရိုက်ထည့်ပါ (ဥပမာ- 500)",
    advanceReasonLabel: "အကြောင်းပြချက်:",
    advanceReasonPlaceholder: "ငွေထုတ်ယူရသည့် အကြောင်းပြချက်",
    advanceSubmitBtn: "လစာကြိုထုတ် လျှောက်လွှာတင်မည်",
    advanceCutoffNotice: "လစာဖြတ်သည့်ရက်: လစဉ် ၁၀ ရက်နှင့် ၂၅ ရက်",
    advancePendingNote: "သင်၏လျှောက်လွှာကို မန်နေဂျာထံ စစ်ဆေးရန် ပို့ပေးပါမည်",
    advanceHistoryTitle: "လစာကြိုထုတ် မှတ်တမ်းများ",

    leaveHeading: "ခွင့်ရက် လျှောက်ထားခြင်း",
    leaveSubheading: "ခွင့်တောင်းရန် အချက်အလက်ဖြည့်ပြီး တင်ပြပါ",
    leaveTypeLabel: "ခွင့်အမျိုးအစား:",
    leaveTypeVacation: "အပန်းဖြေခွင့် (Vacation Leave)",
    leaveTypeSick: "ဆေးခွင့် (Sick Leave)",
    leaveTypeBusiness: "အရေးပေါ်ကိစ္စခွင့် (Business Leave)",
    leaveStartDate: "စတင်သည့်ရက်:",
    leaveEndDate: "ပြီးဆုံးသည့်ရက်:",
    leaveReason: "ခွင့်တောင်းရသည့် အကြောင်းပြချက်:",
    leaveSubmitBtn: "ခွင့်လျှောက်လွှာတင်မည်",
  },
};

interface LanguageContextType {
  language: Language;
  setLanguage: (lang: Language) => void;
  t: TranslationDict;
}

const LanguageContext = createContext<LanguageContextType>({
  language: "th",
  setLanguage: () => {},
  t: translations.th,
});

function isExecutiveContext(): boolean {
  if (typeof window === "undefined") return false;
  if (
    window.location.pathname === "/admin" ||
    window.location.pathname.startsWith("/admin/") ||
    window.location.pathname === "/a" ||
    window.location.pathname.startsWith("/a/")
  ) return true;
  try {
    const url = new URL(window.location.href);
    const role = url.searchParams.get("role");
    if (role === "admin" || role === "ceo") return true;
    let module = url.searchParams.get("module");
    const liffState = url.searchParams.get("liff.state");
    if (liffState) {
      const nested = new URLSearchParams(decodeURIComponent(liffState).replace(/^\?/, ""));
      if (nested.get("role") === "admin" || nested.get("role") === "ceo") return true;
      if (nested.get("module")) module = nested.get("module");
    }
    if (
      module &&
      ["live-board", "advance-approvals", "payroll", "team-directory", "hr-settings"].includes(module)
    ) {
      return true;
    }
  } catch {
    // fallback
  }
  return false;
}

export function LanguageProvider({ children }: { children: React.ReactNode }) {
  const [language, setLanguageState] = useState<Language>(() => {
    if (typeof window !== "undefined") {
      if (isExecutiveContext()) return "th";
      const saved = localStorage.getItem("demo_language") as Language;
      if (saved === "th" || saved === "my") return saved;
    }
    return "th";
  });

  useEffect(() => {
    if (isExecutiveContext()) {
      setLanguageState("th");
    }
  }, []);

  useEffect(() => {
    document.documentElement.lang = language === "my" ? "my" : "th";
  }, [language]);

  const setLanguage = (lang: Language) => {
    setLanguageState(lang);
    if (typeof window !== "undefined") {
      localStorage.setItem("demo_language", lang);
    }
  };

  const t = translations[language] || translations.th;

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  return useContext(LanguageContext);
}

export function LanguageToggle({
  className,
  onSelect,
}: {
  className?: string;
  onSelect?: (lang: Language) => void;
} = {}) {
  const { language, setLanguage } = useLanguage();

  const handleSelect = (lang: Language) => {
    setLanguage(lang);
    onSelect?.(lang);
  };

  return (
    <div
      className={`inline-flex items-center rounded-full bg-slate-100 p-0.5 sm:p-1 border border-slate-200/90 shadow-2xs shrink-0 ${
        className || ""
      }`}
    >
      <button
        type="button"
        onClick={() => handleSelect("th")}
        className={`flex items-center gap-1 sm:gap-1.5 px-2 py-1 sm:px-3 sm:py-1.5 rounded-full text-xs font-black transition-all ${
          language === "th"
            ? "bg-[#f59e0b] text-slate-950 shadow-xs"
            : "text-slate-600 hover:text-slate-900"
        }`}
      >
        <span className="text-xs">🇹🇭</span>
        <span className="text-[11px] sm:text-xs">ไทย</span>
      </button>
      <button
        type="button"
        onClick={() => handleSelect("my")}
        className={`flex items-center gap-1 sm:gap-1.5 px-2 py-1 sm:px-3 sm:py-1.5 rounded-full text-xs font-black transition-all ${
          language === "my"
            ? "bg-[#f59e0b] text-slate-950 shadow-xs"
            : "text-slate-600 hover:text-slate-900"
        }`}
      >
        <span className="text-xs">🇲🇲</span>
        <span className="text-[11px] sm:text-xs">မြန်မာ</span>
      </button>
    </div>
  );
}
